import { Sharepercentage, SharepercentageRes } from '~/types/SharesPercentage';
import axios from './axios';

export const mutateSharesPercentage = (params: Sharepercentage) => {
  return axios
    .post<SharepercentageRes>('/refresh/percentage', null, { params }).then((res) => res.data);

};